import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./Navbar.css";
import { alpha, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import web from '../../../components/images/lacuna.png'
import DashboardIcon from "@material-ui/icons/Dashboard";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import WorkIcon from '@mui/icons-material/Work';
import QuizIcon from '@mui/icons-material/Quiz';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import ExploreIcon from '@mui/icons-material/Explore';
import { Link } from "react-router-dom";


// import { colors } from "../../styles/Colors";
// import { images } from "../../styles/Images";
import NavItem from "./NavItem";
import { bootstrapClassName } from "../../../styles/Styles";
// import ScrollMenuComponent from "../../components/menu/ScrollMenuComponent";
// import AvatarIcon from "../../components/Avatar";



import Dashboard from "@material-ui/icons/Dashboard";
import { Workshop } from "../dashboard/Workshop";
import {Contest} from "../dashboard/Contest"
import { WorkshopDetail } from "../dashboard/WorkshopDetail";
import { ContestDetail } from "../dashboard/ContestDetail";
import {Mentor} from "../dashboard/Mentor";
import {Team} from "../dashboard/Team"
import {Program} from "../dashboard/Program"
import {About} from "../dashboard/About"
import {Blogs} from "../dashboard/Blogs"
import {Career} from "../dashboard/Career"
import {UserList} from '../dashboard/axios/UserList'

 
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto",
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "20ch",
        },
    },
    sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex",
        },
    },
    sectionMobile: {
        display: "flex",
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
}));

export default function NavbarInternal() {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [showVertivalNav, setShowVerticalNav] = useState(true);

    // useEffect(() => {
    //     show(showVertivalNav);
    // }, [showVertivalNav]);

    const toggleVerticalNav = () => {
        setShowVerticalNav(!showVertivalNav);
        // show(!showVertivalNav);
    };

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const resetCount = () => {
        console.log("reset");
    }

    const menuId = "primary-search-account-menu";
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
                sx: {
                    marginLeft: "-10px",
                    overflow: "visible",
                    width: "150px",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                    },
                },
            }}
        >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>My account</MenuItem>
            <MenuItem onClick={() => console.log("logout")}>Logout</MenuItem>
        </Menu>
    );

    const mobileMenuId = "primary-search-account-menu-mobile";
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem>
                <IconButton aria-label="show 4 new mails" color="inherit">
                    <Badge badgeContent={4} color="secondary">
                        <MailIcon />
                    </Badge>
                </IconButton>
                <p>Messages</p>
            </MenuItem>
            <MenuItem>
                <IconButton
                    aria-label="show 11 new notifications"
                    color="inherit"
                >
                    <Badge badgeContent={11} color="secondary">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
                <p>Notifications</p>
            </MenuItem>
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    {/* <AvatarIcon
                        height={30}
                        width={30}
                        username={adminInfo.username}
                    /> */}
                </IconButton>
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );

    return (
        <>
            <div className="sticky-top position-fixed w-100">
                <AppBar
                    position="static"
                    // style={{ backgroundColor: colors.primary }}
                    className="bg-primary"
                >
                    <Toolbar>
                        {/* <IconButton
                            edge="start"
                            // className={classes.menuButton}
                            color="inherit"
                            // aria-label="open drawer"
                            className="navbar-toggler d-md-none collapsed"
                            // type="button"
                            data-toggle="collapse"
                            data-target="#sidebarMenu"
                            aria-controls="sidebarMenu"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <MenuIcon />
                        </IconButton> */}
                        {/* <>
                            <img
                                src={images.Logo}
                                style={{ height: "40px", width: "40px" }}
                            />
                        </> */}
                        <Typography
                            className={classes.title}
                            variant="h6"
                            noWrap
                        >
                            <img src={web} alt="" />
                        </Typography>
                        <IconButton
                            style={{ color: "white" }}
                            onClick={toggleVerticalNav}
                        >
                            <MenuIcon />
                        </IconButton>
                        <div className={classes.grow} />
                        <div className={classes.sectionDesktop}>
                            {/* <ScrollMenuComponent
                                icon={<MailIcon />}
                                marginLeft="-100px"
                                name="complain"
                                className="whiteColor"
                                data={complain && complain.data}
                                blockHeight={48}
                                blockWidth="40ch"
                                newMessageCount={complain && complain.count}
                                resetCount={resetCount}
                                link="/complain"
                            />
                            <ScrollMenuComponent
                                icon={<NotificationsIcon />}
                                marginLeft="-60px"
                                name="notification"
                                className="whiteColor"
                                data={notification && notification.data}
                                blockHeight={48}
                                blockWidth="40ch"
                                newMessageCount={
                                    notification && notification.count
                                }
                                resetCount={resetCount}
                            /> */}
                            <IconButton
                                edge="end"
                                aria-label="account of current user"
                                aria-controls={menuId}
                                aria-haspopup="true"
                                onClick={handleProfileMenuOpen}
                                color="inherit"
                            >
                                {/* <AvatarIcon username={adminInfo.username} /> */}
                            </IconButton>
                        </div>
                        <div className={classes.sectionMobile}>
                            <IconButton
                                aria-label="show more"
                                aria-controls={mobileMenuId}
                                aria-haspopup="true"
                                onClick={handleMobileMenuOpen}
                                color="inherit"
                            >
                                <MoreIcon />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
                {renderMobileMenu}
                {renderMenu}
            </div>

            {/* Start of Vertical Navbar */}
            <nav
                id="sidebarMenu"
                className={`${bootstrapClassName.navClassname} bg-primary`}
                style={{
                    // backgroundColor: colors.primary,
                    left: showVertivalNav ? "0%" : "-100%",
                    transition: "all 0.5s ease-in-out",
                }}
            >
                <div className={bootstrapClassName.navFixed}>
                    <ul className="nav flex-column">
                      
                        <NavItem
                            title="dashboard"
                            icon={
                                <DashboardIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                    className="icn"
                                />
                            }
                            link="/"
                        />
                          <Link to="/workshop">
                        <NavItem
                            title="workshop"
                            icon={
                                <WorkIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/workshop"
                        />
                        </Link>
                        <NavItem
                            title="contest"
                            icon={
                                <QuizIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/contest"
                        />
                        <NavItem
                            title="Blogs"
                            icon={
                                <BorderColorIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/blogs"
                        />
                        <NavItem
                            title="Events"
                            icon={
                                <EmojiEventsIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/events"
                        />
                        <NavItem
                            title="Opportunity"
                            icon={
                                <ViewInArIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/opportunity"
                        />
                        <NavItem
                            title="more"
                            icon={
                                <ExploreIcon
                                    Size="2em"
                                    style={{ color: "white" }}
                                />
                            }
                            link="more"
                        />
                             <NavItem
                            title="Mentor"
                            icon={
                                <BorderColorIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/mentor"
                        />
                           <NavItem
                            title="Career"
                            icon={
                                <BorderColorIcon
                                    fontSize="small"
                                    style={{ color: "white" }}
                                />
                            }
                            link="/career"
                        />
                    </ul>
                </div>
            </nav>

            {/* End of Vertical Navbar */}
            

                <Routes>
                    <Route path="/" exact element={<Dashboard />} />
                    <Route path="/workshop" element={<Workshop />} />
                    <Route path="/contest" element={<Contest/>} />
                    <Route path="/workshopDetail" element={<WorkshopDetail />} />
                    <Route path="/contestDetail" element={<Contest/>} />
                    <Route path="/mentor" element={<Mentor/>} />
                    <Route path="/team" element={<Team/>} />   
                    <Route path="/about" element={<About/>} />
                    <Route path="/program" element={<Program/>} />
                    <Route path="/blogs" element={<Blogs/>} />
                    <Route path="/career" element={<Career/>} />
                </Routes>
        
              <UserList/>

        </>
    );
}

const styles = {
    menuText: {
        marginLeft: 10,
        fontSize: 16,
        // color: colors.text,
        color: "white",
    },
};
